/**
 * apiClient — single source of truth for HTTP requests.
 *
 * Re-exports the global axios default instance configured in AuthContext
 * (Bearer token header, response interceptor for 401/403 auth failures,
 * conditional withCredentials for same-origin vs cross-origin).
 *
 * NEW CODE should import from here:
 *     import api from '../utils/apiClient';
 *     const { data } = await api.get('/endpoint');
 *
 * Legacy `authFetch` (utils/authFetch.js) and direct `fetch` calls remain
 * supported and mirror the same auth-failure behaviour, but axios is the
 * preferred HTTP client going forward (single client policy).
 */
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

// AuthContext.js installs the response interceptor + Authorization header
// on the default axios instance at module load time, so we re-use it here.
const api = axios;

// Convenience helper: build a fully-qualified API URL.
export const apiUrl = (path = '') => {
  const clean = path.startsWith('/') ? path : `/${path}`;
  return `${API_BASE}${clean}`;
};

export default api;
